import { UseFieldConfig } from 'react-final-form'

export function toIBAN(value: string | undefined) {
  if (value === undefined) {
    return value
  }

  return (
    value
      // DE etc.
      .replace(/[^\dA-Za-z]/g, '')
      .toUpperCase()

      // numbers: XX XXXX XXXX XXXX XX..
      .replace(/^([a-zA-Z]{0,2}\d{2})/, '$1 ')
      .replace(/(\d{4})/g, '$1 ')

      .trim()
  )
}

export function fromIBAN(iban: string) {
  return iban.replace(/\s/g, '')
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ibanFieldConfig: UseFieldConfig<any> = {
  parse: fromIBAN,
  format: toIBAN
}
